import { useLocation } from "react-router-dom";
import { Reveal, Eyebrow } from "@/components/Kinetic";
import { SITE } from "@/data/site";

const PRIVACY = {
  title: "Privacy Policy",
  intro:
    "Nanak Chauffeurs respects your privacy. This policy explains what information we collect when you use our website and reservation services, and how we use it.",
  sections: [
    { h: "Information we collect", p: "We collect the details you provide when booking or contacting us — such as your name, email, phone number, pickup and drop-off information, and trip preferences. Online reservations are processed securely by our booking provider, LimoAnywhere." },
    { h: "How we use it", p: "Your information is used solely to arrange, confirm and deliver your transportation, to communicate with you about your trip, and to improve our service. We do not sell your personal information." },
    { h: "Sharing", p: "We share trip details only with the chauffeur assigned to your reservation and with our booking and payment providers as necessary to fulfil your request." },
    { h: "Data security", p: "We use reasonable administrative and technical safeguards to protect your information. Payment and reservation data are handled by our PCI-compliant booking provider." },
    { h: "Your choices", p: "You may request access to, correction of, or deletion of your personal information by contacting us at the address below." },
  ],
};

const TERMS = {
  title: "Terms of Service",
  intro:
    "These terms govern your use of the Nanak Chauffeurs website and reservation services. By booking with us, you agree to the following.",
  sections: [
    { h: "Reservations", p: "All reservations are subject to availability and confirmation. Reservations made online are processed and confirmed through our booking provider, LimoAnywhere." },
    { h: "Cancellations", p: "Cancellation and change policies are presented at the time of booking. Please review them before confirming your reservation." },
    { h: "Conduct & safety", p: "For everyone's safety, passengers must comply with applicable laws and reasonable chauffeur instructions. We reserve the right to decline or end service for unsafe or unlawful conduct." },
    { h: "Liability", p: "Nanak Chauffeurs provides professional ground transportation only. We are not an aviation provider and do not arrange flights or aircraft. Our liability is limited to the extent permitted by law." },
    { h: "Changes", p: "We may update these terms from time to time. Continued use of our services constitutes acceptance of the current terms." },
  ],
};

export default function Legal() {
  const { pathname } = useLocation();
  const data = pathname.startsWith("/terms") ? TERMS : PRIVACY;
  return (
    <main data-testid="page-legal" className="pt-20">
      <section className="mx-auto max-w-3xl px-5 py-20 sm:px-8 lg:py-28">
        <Reveal>
          <Eyebrow>Legal</Eyebrow>
          <h1 className="mt-6 font-display text-5xl font-bold leading-[1.05] text-ivory sm:text-6xl">
            {data.title}
          </h1>
          <p className="mt-6 text-base leading-relaxed text-silver/85">{data.intro}</p>
        </Reveal>
        <div className="mt-12 space-y-10">
          {data.sections.map((s) => (
            <Reveal key={s.h}>
              <h2 className="font-display text-2xl font-semibold text-ivory">{s.h}</h2>
              <p className="mt-3 text-base leading-relaxed text-silver/80">{s.p}</p>
            </Reveal>
          ))}
          <Reveal>
            <p className="text-base leading-relaxed text-silver/80">
              Questions? Contact us at{" "}
              <a href={`mailto:${SITE.email}`} className="gold-text" data-testid="legal-email-link">
                {SITE.email}
              </a>
              .
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
